export default "__VITE_ASSET__3PkOOz85__"